<div class="modal-header bg-dark">
    <h4 class="modal-title document-preview-title" [title]="fileName">{{ fileName }}</h4>
    <button type="button" class="close" aria-label="Chiudi" (click)="activeModal.dismiss()">
        <i class="icons-office-52"></i>
    </button>
</div>
<div class="modal-body document-preview-body" [class.document-preview-body-dark]="previewPane?.hasPdf">
    <app-document-preview-pane *ngIf="fileLoader"
                               [fileName]="fileName"
                               [loadFile]="fileLoader"></app-document-preview-pane>
</div>
<div class="modal-footer">
    <button type="button"
            class="btn btn-default btn-blue btn-embossed"
            (click)="download()"
            [disabled]="previewPane?.loading || previewPane?.downloading">
        <i class="fa fa-download"></i>Download
    </button>
    <button type="button" class="btn btn-default btn-embossed" (click)="activeModal.dismiss()">Chiudi</button>
</div>
